﻿import { Property } from "csstype";

import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Circle from "ol/style/Circle";

import { FitOptions } from "../../extensions/HasViewFitExtensions";

export const PICK_PORT_CURSOR: Property.Cursor = 'crosshair';

export const IMAGE_ATTRIBUTE = "Pictorial representation";
export const TEXTUAL_ATTRIBUTE = "Textual description";

export const BATHYMETRY_DEPTH_ID = 'DEPT-PICK-REPORT';
export const PANEL_CLASS_NAME = 'pick-report-panel';
export const PANEL_CONTENT_CLASS_NAME = `${PANEL_CLASS_NAME}-content`;

const r = 36, g = 85, b = 128
const ro = 255, go = 255, bo = 255;

export const DEFAULT_GEOMETRY_STYLE = [
    new Style({
        stroke: new Stroke({
            color: [ro, go, bo, 0.7],
            width: 4
        })
    }),
    new Style({
        stroke: new Stroke({
            color: [r, g, b, 1],
            width: 2
        }),
        fill: new Fill({
            color: [r, g, b, 0.25]
        }),
        image: new Circle({
            fill: new Fill({
                color: [r, g, b, 1]
            }),
            stroke: new Stroke({
                color: [ro, go, bo, 0.7],
                width: 1
            }),
            radius: 8
        })
    }),
    new Style({
        image: new Circle({
            fill: new Fill({
                color: [ro, go, bo, 1]
            }),
            radius: 2
        })
    }),
]

export const DEFAULT_FIT_OPTIONS: FitOptions = {
    smartFit: false,
    relativeZoomAdjustment: 0.9
}